import React, { useEffect, useState } from "react"
import { Col, OverlayTrigger, Row, Spinner, Tab, Table, Tabs, Tooltip } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import Flag from "react-world-flags"
import api from "../../api"
import { SERVICE_TYPE } from "../../constants/constants"
import { getImageSrc, numberFormatter } from "../../utils/commonFunctions"

const ExpandedRow = ({
    row,
    address,
    countryList
}: {
    row: Record<string, any>
    address: Record<string, any>
    countryList: Record<string, any>[]
}) => {
    const { t } = useTranslation()
    const [tab, setTab] = useState("read-personal-info")
    const [customerShippingRates, setCustomerShippingRates] = useState([] as Record<string, any>[])
    const [customerValueAddedservices, setCustomerValueAddedservices] = useState([] as Record<string, any>[])
    const [customerStats, setCustomerStats] = useState({} as Record<string, any>)
    const [loading, setLoading] = useState(false)

    const getCustomerSRList = async () => {
        try {
            const res = await api.pricing.listShippingRates(row?.id)
            if (res?.data?.status) {
                setCustomerShippingRates([...res?.data?.payload])
            }
        } catch (error) {
            console.error(error)
        }
    }

    const getCustomerVASList = async () => {
        try {
            const res = await api.pricing.listCustomerValueAddedServices(row?.id)
            if (res?.data?.status) {
                setCustomerValueAddedservices([...res?.data?.payload])
            }
        } catch (error) {
            console.error(error)
        }
    }

    const getCustomerStats = async () => {
        try {
            const res = await api.customer.customerStats(row?.user_pin)
            if (res?.data?.status) {
                setCustomerStats({ ...res?.data?.payload })
            }
        } catch (error) {
            console.error(error)
        }
    }

    useEffect(() => {
        if (row?.id) {
            setLoading(true)
            getCustomerSRList()
            getCustomerVASList()
            getCustomerStats()
            setLoading(false)
        }
    }, [row?.id])

    return loading ? (
        <div className="d-flex justify-content-center align-items-center py-5">
            <Spinner animation="border" />
        </div>
    ) : (
        <>
            <Row className="justify-content-around mb-3">
                {/* {Object.values(customerStats)?.map(v =>  */}
                <Col lg={2} className="d-flex align-items-stretch px-1">
                    <div className="card p-4 w-100">
                        <h1 className="table-header-title">
                            {numberFormatter.format(customerStats?.parcel_count?.toFixed(2) || 0.0)}
                        </h1>
                        <p>{t("Parcels")}</p>
                    </div>
                </Col>
                <Col lg={2} className="d-flex align-items-stretch px-1">
                    <div className="card p-4 w-100">
                        <h1 className="table-header-title">
                            {numberFormatter.format(customerStats?.shipment_count?.toFixed(2) || 0.0)}
                        </h1>
                        <p>{t("Shipments")}</p>
                    </div>
                </Col>
                <Col lg={2} className="d-flex align-items-stretch px-1">
                    <div className="card p-4 w-100">
                        <h1 className="table-header-title">
                            ${numberFormatter.format(customerStats?.total_revenue?.toFixed(2) || 0.0)}
                        </h1>
                        <p>{t("Revenue")}</p>
                    </div>
                </Col>
                <Col lg={2} className="d-flex align-items-stretch px-1">
                    <div className="card p-4 w-100">
                        <h1 className="table-header-title">
                            ${numberFormatter.format(customerStats?.cost_of_shipping?.toFixed(2) || 0.0)}
                        </h1>
                        <p>{t("Cost of Shipment")}</p>
                    </div>
                </Col>
                <Col lg={2} className="d-flex align-items-stretch px-1">
                    <div className="card p-4 w-100">
                        <h1 className="table-header-title">
                            {numberFormatter.format(customerStats?.gross_profit?.toFixed(2) || 0.0)}%
                        </h1>
                        <p>{t("GP")}</p>
                    </div>
                </Col>

                {/* )} */}
            </Row>
            <Row className="mt-4 mx-1 d-flex tabs-data">
                <Tabs
                    id="customer-tab"
                    activeKey={tab}
                    onSelect={(k: any) => {
                        setTab(k)
                    }}
                    className="mb-3">
                    <Tab
                        eventKey="read-personal-info"
                        className="text-start overflow-x-hidden"
                        title={t("Personal & Shipping information")}>
                        <Row className="expanding-row px-4 py-4">
                            <Col xs={12} sm={12} md={12} lg={5}>
                                <div className="heading text-muted">{t("Personal_Information")}</div>
                                <Row className="expand-data">
                                    <Col xs={12} sm={12} md={12} lg={4} className="label">
                                        {t("First_Name")}
                                    </Col>
                                    <Col xs={12} sm={12} md={12} lg={8} className="value">
                                        {row.fname}
                                    </Col>
                                </Row>
                                <Row className="expand-data">
                                    <Col xs={12} sm={12} md={12} lg={4} className="label">
                                        {t("Last_Name")}
                                    </Col>
                                    <Col xs={12} sm={12} md={12} lg={8} className="value">
                                        {row.lname}
                                    </Col>
                                </Row>
                                <Row className="expand-data">
                                    <Col xs={12} sm={12} md={12} lg={4} className="label">
                                        {t("Email")}
                                    </Col>
                                    <Col xs={12} sm={12} md={12} lg={8} className="value">
                                        {row.email}
                                    </Col>
                                </Row>
                                <Row className="expand-data">
                                    <Col xs={12} sm={12} md={12} lg={4} className="label">
                                        {t("Status")}
                                    </Col>
                                    <Col xs={12} sm={12} md={12} lg={8} className="value">
                                        {row.status === 1 ? t("Active") : "inactive"}
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={7}>
                                <div className="heading text-muted">{t("Home_Shipping_Address")}</div>
                                <Row className="expand-data">
                                    <Col xs={12} sm={12} md={12} lg={4} className="label">
                                        {t("Country")}
                                    </Col>
                                    <Col xs={12} sm={12} md={12} lg={8} className="value">
                                        {address ? address.country : "-"}
                                    </Col>
                                </Row>
                                <Row className="expand-data">
                                    <Col xs={12} sm={12} md={12} lg={4} className="label">
                                        {t("City")}
                                    </Col>
                                    <Col xs={12} sm={12} md={12} lg={8} className="value">
                                        {address ? address.city : "-"}
                                    </Col>
                                </Row>
                                <Row className="expand-data">
                                    <Col xs={12} sm={12} md={12} lg={4} className="label">
                                        {t("Postal_Code")}
                                    </Col>
                                    <Col xs={12} sm={12} md={12} lg={8} className="value">
                                        {address ? address.postal_code : "-"}
                                    </Col>
                                </Row>
                                <Row className="expand-data">
                                    <Col xs={12} sm={12} md={12} lg={4} className="label">
                                        {t("Address")}
                                    </Col>
                                    <Col xs={12} sm={12} md={12} lg={8} className="value">
                                        {address ? address.address : "-"}
                                    </Col>
                                </Row>
                                <Row className="expand-data">
                                    <Col xs={12} sm={12} md={12} lg={4} className="label">
                                        {t("Phone")}
                                    </Col>
                                    <Col xs={12} sm={12} md={12} lg={8} className="value">
                                        {address ? address.phone : "-"}
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Tab>
                    <Tab
                        eventKey="read-shipping-rates"
                        className="text-start overflow-x-hidden"
                        title={t("Shipping Discounts")}>
                        <div className="table-responsive">
                            <Table>
                                <thead className="custom-thead">
                                    <tr className="border rounded">
                                        <th className="col-2">Warehouse</th>
                                        <th className="col-3">Shipping Co. & Service</th>
                                        <th className="col-2">Destination</th>
                                        <th className="col-2">Weight Ranges</th>
                                        <th className="col-2">Discount %</th>
                                    </tr>
                                </thead>
                                <tbody className="text-start custom-tbody">
                                    {customerShippingRates?.map((shippingRate) => (
                                        <tr className="rounded" key={`${shippingRate?.id}-shipping-rate`}>
                                            <td className="col-2 d-flex align-items-center">
                                                <Flag
                                                    className="w-25"
                                                    code={shippingRate?.warehouse?.country}
                                                />
                                                &nbsp;&nbsp;<span>{shippingRate?.warehouse?.country}</span>
                                            </td>
                                            <td className="col-3 d-flex align-items-center">
                                                <img
                                                    className="w-25"
                                                    src={getImageSrc(
                                                        shippingRate?.shipping_service
                                                            ?.replaceAll("_", " ")
                                                            ?.toLowerCase()
                                                    )}
                                                />
                                                &nbsp;&nbsp;
                                                <span className="text-capitalize text-muted">
                                                    {shippingRate?.shipping_service
                                                        ?.replaceAll("_", " ")
                                                        ?.toLowerCase()}
                                                </span>
                                            </td>
                                            <td className="col-2 d-flex align-items-center">
                                                {shippingRate?.countries?.map((c: string, index: number) => (
                                                    <OverlayTrigger
                                                        placement="bottom"
                                                        delay={{ show: 250, hide: 400 }}
                                                        overlay={
                                                            <Tooltip id={`${c}-tooltip`}>
                                                                {
                                                                    countryList?.find(
                                                                        (country: Record<string, any>) =>
                                                                            country?.iso2_code === c
                                                                    )?.name
                                                                }
                                                            </Tooltip>
                                                        }>
                                                        <span className="tr-pointer">
                                                            {c}{" "}
                                                            {index === shippingRate?.countries?.length - 1
                                                                ? ""
                                                                : ", "}
                                                        </span>
                                                    </OverlayTrigger>
                                                ))}
                                            </td>
                                            <td className="col-2 text-center">
                                                {shippingRate?.slabs
                                                    ?.sort(
                                                        (a: Record<string, any>, b: Record<string, any>) =>
                                                            a.id - b.id
                                                    )
                                                    .map((s: Record<string, any>) => (
                                                        <span
                                                            className="d-block mb-3"
                                                            key={
                                                                s?.id
                                                            }>{`${s?.min_weight} - ${s?.max_weight} ${s?.weight_unit}`}</span>
                                                    ))}
                                            </td>
                                            <td className="col-2">
                                                {shippingRate?.slabs
                                                    ?.sort(
                                                        (a: Record<string, any>, b: Record<string, any>) =>
                                                            a.id - b.id
                                                    )
                                                    .map((s: Record<string, any>) => (
                                                        <strong
                                                            className="d-block mb-3"
                                                            key={`${s?.id}-discount`}>
                                                            {`${s?.discount_value}`}
                                                            {`${s?.discount_type === SERVICE_TYPE["0"] ? "$" : "%"}`}
                                                        </strong>
                                                    ))}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </Tab>
                    <Tab
                        eventKey="read-services"
                        className="text-start overflow-x-hidden"
                        title={t("VAS Discounts")}>
                        <div className="table-responsive">
                            <Table>
                                <thead className="custom-thead">
                                    <tr className="border rounded">
                                        <th className="col-3">Services</th>
                                        <th className="col-2">Warehouse</th>
                                        <th className="col-2">Default</th>
                                        <th className="col-2">New Rate</th>
                                    </tr>
                                </thead>
                                <tbody className="text-start custom-tbody">
                                    {customerValueAddedservices?.map((vas) => (
                                        <tr className="rounded" key={`${vas?.id}-vas`}>
                                            <td className="col-3">
                                                <span>{vas?.service}</span>
                                            </td>
                                            <td className="col-2 d-flex align-items-center">
                                                <Flag className="w-25" code={vas?.Warehouse?.country} />
                                                &nbsp;&nbsp;<span>{vas?.Warehouse?.country}</span>
                                            </td>
                                            <td className="col-2 d-flex">
                                                <span>{vas?.ValueAddedService?.service_value}</span>
                                                <span>
                                                    {vas?.ValueAddedService?.service_type === "flat"
                                                        ? "$"
                                                        : "%"}
                                                </span>
                                            </td>
                                            <td className="col-2 d-flex">
                                                <span>{vas?.service_value}</span>
                                                <span>{vas?.service_type === "flat" ? "$" : "%"}</span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </Tab>
                </Tabs>
            </Row>
        </>
    )
}
export default ExpandedRow
